import React from 'react';

// Modules
import EmailOptInTrigger from 'core/modules/EmailOptInTrigger/EmailOptInTrigger';
import RedirectToTargetLandingPage from 'core/modules/RedirectToTargetLandingPage/RedirectToTargetLandingPage';
import PageErrorBoundary from 'core/modules/ErrorBoundaries/PageErrorBoundary';
import EmailUnsubscribeComponent from 'core/modules/EmailUnsubscribe/EmailUnsubscribe';

function EmailUnsubscribe() {
  return (
    <RedirectToTargetLandingPage>
      <PageErrorBoundary>
        <EmailUnsubscribeComponent />
        <EmailOptInTrigger />
      </PageErrorBoundary>
    </RedirectToTargetLandingPage>
  );
}

export default EmailUnsubscribe;
